import { useQuery } from '@tanstack/react-query';

import { listEmbedKeys } from '@/services/external-chat/embed-keys';
import { unwrap } from '@/services/external-chat/detail-error';
import type { EmbedApiKey } from '@/services/external-chat/types';

export const embedKeysQueryKey = (orgId?: string, collectionId?: string) => [
  'external-chat-embed-keys',
  orgId,
  collectionId,
];

export const useEmbedKeys = (orgId?: string, collectionId?: string) =>
  useQuery<EmbedApiKey[], Error>({
    queryKey: embedKeysQueryKey(orgId, collectionId),
    queryFn: async () =>
      unwrap(await listEmbedKeys(collectionId!)).keys.filter(
        (key) => key.is_active,
      ),
    enabled: !!orgId && !!collectionId,
  });
